<div class="card">
    <p class="card-title"><i class="fas fa-history"></i> Histórico de Login</p>

    <div class="search-head">
        <div class="search-head__input">
            <i class="fa fa-search"></i>
            <input type="text" class="form-control"
                placeholder="Buscar por nome, login, IP ou ação..."
                [(ngModel)]="term"
                (ngModelChange)="onSearch($event)">
        </div>

        <div class="search-head__filters">
            <select class="form-control" title="Ação"
                [(ngModel)]="action"
                (ngModelChange)="onFilterChange()">
                <option *ngFor="let option of actionOptions" [value]="option.value">{{option.label}}</option>
            </select>
            <input type="date" class="form-control" title="Data inicial"
                [(ngModel)]="startDate"
                [max]="endDate"
                (ngModelChange)="onFilterChange()">
            <input type="date" class="form-control" title="Data final"
                [(ngModel)]="endDate"
                [min]="startDate"
                (ngModelChange)="onFilterChange()">
            <a href="javascript:;" class="btn btn-small btn-outline-secondary"
                (click)="clearFilters()">
                <i class="fas fa-times"></i> Limpar
            </a>
        </div>

        <div class="search-head__buttons">
            <a href="javascript:;"
                class="btn btn-outline-primary"
                id="btnGerarExcel"
                (click)="doExport()">
                <i class="fa fa-file-excel"></i> Exportar
            </a>
            <a routerLink="/users" class="btn btn-small btn-outline-secondary">
                <i class="fas fa-arrow-left"></i> Usuários
            </a>
        </div>
    </div>

    <div class="process_list">
        <div class="process-item process-item_head">
          <div class="process-item__row">
            <p>Nome</p>
          </div>
          <div class="process-item__row">
            <p>Login</p>
          </div>
          <div class="process-item__row">
            <p>Data / Hora</p>
          </div>
          <div class="process-item__row">
            <p>IP de origem</p>
          </div>
          <div class="process-item__row">
            <p>Ação</p>
          </div>
        </div>

        <div class="process-item"
            *ngFor="let log of logs | paginate: { id: 'loginHistory', itemsPerPage: pageSize, currentPage: currentPage, totalItems: totalItems }">
            <div class="process-item__row">
              <p>{{log.name || '-'}}</p>
            </div>
            <div class="process-item__row">
              <p>{{log.userName || '-'}}</p>
            </div>
            <div class="process-item__row">
              <p>{{log.actionTime | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
            </div>
            <div class="process-item__row">
              <p>{{log.remoteIpAddress || '-'}}</p>
            </div>
            <div class="process-item__row">
              <p>{{actionLabel(log.action)}}</p>
            </div>
        </div>
    </div>

    <p class="empty-state" *ngIf="!logs.length">Nenhum registro encontrado.</p>

    <pagination-controls id="loginHistory" (pageChange)="onPageChange($event)"></pagination-controls>
</div>
